import { React } from 'react'

function Selectbranch(props) {


    return (
        <div className="container my-4" id='branch-selector'>
            <h4 className="text-center">Select Your Branch</h4>
            <div className="row my-3">
                <div className="">
                    <div id="list-example" className="list-group">
                        <div className="list-group-item list-group-item-action selectors-item"
                            onClick={(e) => { props.setDisplay('Semester'); props.setBranch('Computer Science') }}
                        >👉 Computer Science & Engineering</div>
                        <div className="list-group-item list-group-item-action selectors-item"
                            onClick={(e) => { props.setDisplay('Semester'); props.setBranch('Electronics') }}
                        >👉 Electronics Engineering</div>
                        <div className="list-group-item list-group-item-action selectors-item"
                            onClick={(e) => { props.setDisplay('Semester'); props.setBranch('Information Technology') }}
                        >👉 Information Technology</div>
                        <div className="list-group-item list-group-item-action selectors-item"
                            onClick={(e) => { props.setDisplay('Semester'); props.setBranch('Mechanical') }}
                        >👉 Mechanical Engineering</div>
                        <div className="list-group-item list-group-item-action selectors-item"
                            onClick={(e) => { props.setDisplay('Semester'); props.setBranch('Electrical') }}
                        >👉 Electrical Engineering</div>
                        <div className="list-group-item list-group-item-action selectors-item"
                            onClick={(e) => { props.setDisplay('Semester'); props.setBranch('Instrumental and control Eng') }}
                        >👉 Instrumental Control</div>

                    </div>
                </div>
            </div>
        </div>
    )
}

export default Selectbranch;



/*

Mechanical Engineering.
Electronics Engineering.
Electrical Engineering.
Information Technology
Instrumental and control Eng
Computer Science & Engineering 
*/